import { Box, Button, List, ListItem, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { ClientAPI } from '../../../utils/api'
import moment from 'moment'
const Clients = () => {
    const [currentClient, setCurrentClient] = useState<any>()
    const [orderType,setOrderType] = useState(0)
    const { data: result } = useQuery<any>(['listClients',orderType], () => ClientAPI.list(0,100000,orderType))
    const { data: coachingOrders, refetch } = useQuery<any>(['listClientCoachingOrders', currentClient?.id], () => ClientAPI.listCoachingOrders(currentClient.id), { enabled: false })

    useEffect(() => {
        if (currentClient) {
            refetch()
        }
    }, [currentClient])

    return <>
        <Box display="flex" justifyContent="space-between">
            <Box>
                <Typography variant="h6">来访者管理</Typography>
            </Box>
            <Box>
            </Box>
        </Box>
        <Box mt={2}>
            <Paper>
                <Box height="calc( 100vh - 160px)" display="flex" >
                    <Box width="200px" flexShrink={0} height="100%" borderRight="1px solid #e1e1e1">
                        <Box p={1.5}>
                        <TextField select fullWidth value={orderType} onChange={e=> setOrderType(+e.target.value)} size="medium">
                            <MenuItem value={0}>全部</MenuItem>
                            <MenuItem value={2}>1对1教练</MenuItem>
                            <MenuItem value={5}>团体教练</MenuItem>
                            <MenuItem value={1}>首次约谈</MenuItem>
                        </TextField>
                        </Box>
                        <List style={{maxHeight: 'calc( 100% - 80px)',overflowY: 'scroll'}}>
                            {result?.data.map((client: any) => <ListItem key={client.id} selected={currentClient?.id === client.id} onClick={() => setCurrentClient(client)} button >
                                <Box>
                                    <Typography>{client.name}</Typography>
                                    <Typography>{client.mobile}</Typography>
                                </Box>
                            </ListItem>)}
                        </List>
                    </Box>
                    <Box width="100%" p={2}>
                        <TableContainer style={{ height: '100%' }}>
                            <Table stickyHeader>
                                <TableHead >
                                    <TableCell>类型</TableCell>
                                    <TableCell align="center">负责教练</TableCell>
                                    <TableCell align="center">金额</TableCell>
                                    <TableCell align="center">付款日期</TableCell>
                                    <TableCell align="center">当前状态</TableCell>
                                    <TableCell align="center">完成日期</TableCell>
                                </TableHead>
                                <TableBody>
                                    {coachingOrders?.map((o: any) => <TableRow>
                                        <TableCell>{o.type_name}</TableCell>
                                        <TableCell align="center">{o.coach_name}</TableCell>
                                        <TableCell align="center">{o.amount / 100}</TableCell>
                                        <TableCell align="center">{moment(o.order_finish_time).format('YYYY/MM/DD HH:mm')}</TableCell>
                                        <TableCell align="center"><Typography variant="body2" color={o.status==='ongoing'?'primary': 'inherit'}>{o.status_name}</Typography></TableCell>
                                        <TableCell align="center">{o.finish_time ? moment(o.finish_time).format('YYYY/MM/DD HH:mm') : '-'}</TableCell>
                                    </TableRow>)}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Box>
            </Paper>
        </Box>
    </>
}

export default Clients